import { saveAs } from 'file-saver';
import * as ExcelJS from "exceljs";
import {capitalizeFirstLetter, statusMap} from "../components/common/helpers";

export const saveExcel = async (workbook, fileName) => {
    // Generate Excel file as a buffer
    const buffer = await workbook.xlsx.writeBuffer();

    // Create a Blob from the buffer and save the file
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, fileName || fileName);
};

export const createReadinessExcelReport = async (readinessType, readinessDataByDate) => {

    if (Object.keys(readinessDataByDate).length === 0) {
        return
    }

    const workbook = new ExcelJS.Workbook();

    const headerStyling = {
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: '006BD6'}
        },
        font: {color: {argb: 'FFFFFF'}, bold: true}
    }
    const readinessTypeCapitalized = capitalizeFirstLetter(readinessType)
    const worksheet = workbook.addWorksheet(readinessTypeCapitalized.concat(" Readiness"))

    const isAssetOrMember = () => {
        return readinessType === "member" || readinessType === "asset";
    }

    Object.entries(readinessDataByDate).forEach(([date, readinessData]) => {
        let tempreadinessList = []
        if (isAssetOrMember()) {
             tempreadinessList = [...readinessData.ready, ...readinessData.notReady]
        }else{
            tempreadinessList = [...readinessData.ready, ...readinessData.notReady, ...readinessData.noReport]
        }

        const readinessList = tempreadinessList


        const worksheetColumns = [
            {header: readinessTypeCapitalized, key: 'readinessType', width: 30},
            {header: 'Status', key: 'status', width: 20},
            {header: 'Reason', key: 'reason', width: 20},
            {header: 'Reported By', key: 'reportedBy', width: 20},
            {header: 'Reported Date', key: 'reportedDate', width: 20}
        ]

        if (isAssetOrMember()) {
            worksheetColumns.splice(1, 0,{header: 'Team', key: 'team', width: 30})
        }

        worksheet.columns = worksheetColumns

        if (readinessList.length > 0) {
            readinessList.forEach(readiness => {
                const data = {}
                data.readinessType = readiness.info.name
                if (isAssetOrMember()) {
                    data.team = readiness.teamName
                }
                data.status = statusMap[readiness.status]
                data.reason = statusMap[readiness.statusReason]
                data.reportedBy = readiness.createdBy.name
                data.reportedDate = date
                worksheet.addRow(data)
            })
        }

        const headerRow = worksheet.getRow(1)
        headerRow.eachCell(cell => {
            cell.fill = headerStyling.fill
            cell.font = headerStyling.font
        });

    })

    await saveExcel(workbook, readinessType.concat("_readiness.xlsx"))
}
